import { capitalize } from "lodash-es";

import { CopyTextIcon } from "src/base-components/CopyTextIcon";
import { ApiEndpointsDisplayData } from "src/connections/utils/apiEndpoints";
import { Accordion } from "src/design-system/Accordion";

type ApiEndpointsDisplayProps = {
  endpoints: ApiEndpointsDisplayData;
};

export const ApiEndpointsDisplay: React.FC<ApiEndpointsDisplayProps> = ({
  endpoints,
}) => {
  if (Object.keys(endpoints).length === 0) {
    return null;
  }

  const entries = Object.entries(endpoints);

  const content = (
    <div className="flex flex-col gap-4">
      <p className="mb-2 font-inter-normal-12px text-gray-600">
        Full API endpoints for this integration. These are the complete URLs
        used when making requests to the third-party service.
      </p>
      {entries.map(([resourceName, envEndpoints]) => (
        <div key={resourceName} className="flex flex-col gap-3">
          <span className="font-inter-semibold-13px text-gray-900">
            {resourceName}
          </span>
          <div className="flex flex-col gap-3 rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
            {Object.entries(envEndpoints).map(([environment, { url }]) => (
              <div
                key={`${resourceName}-${environment}`}
                className="flex flex-col gap-2"
              >
                <div className="flex items-center justify-between">
                  <span className="font-inter-medium-13px text-gray-900">
                    {capitalize(environment)}
                  </span>
                  <CopyTextIcon
                    dataLoc={`copy-api-endpoint-${resourceName}-${environment}`}
                    feedback="inline"
                    tooltip={`Copy ${resourceName} ${environment} endpoint`}
                    value={url}
                  />
                </div>
                <pre className="m-0 overflow-x-auto whitespace-pre-wrap break-all rounded border border-gray-200 bg-white px-3 py-2 font-inter-normal-12px font-mono text-gray-600">
                  {url}
                </pre>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <>
      <hr className="mt-6 mb-8 h-px w-full bg-gray-100" />
      <Accordion dataLoc="api-endpoints-accordion">
        <Accordion.Item label="View API Endpoints" value="api-endpoints">
          <div className="py-4">{content}</div>
        </Accordion.Item>
      </Accordion>
    </>
  );
};
